import { createApiRef } from '@backstage/core-plugin-api';
import { JsonSchema } from './AccentuateClient';
import { AccentuateResponse } from '@dweber019/backstage-plugin-accentuate-common';
import { JsonObject } from '@backstage/types';
import { Entity } from '@backstage/catalog-model';

/** @public */
export interface AccentuateApi {
  /** @public */
  update(entityRef: string, data: JsonObject): Promise<AccentuateResponse>;
  /** @public */
  getSchema(entity: Entity): JsonSchema | undefined;
  /** @public */
  refresh(entityRef: string): Promise<void>;
}
export interface CreatePullRequestOptions {
  /** GitHub repository URL (example: https://github.com/owner/repo) */
  repositoryUrl: string;
  /** Content to include in the catalog-info.yaml file */
  fileContent: string;
  /** Target path where the file should be created (optional, defaults to catalog-info.yaml at the root) */
  targetPath?: string;
  /** Pull Request title (optional) */
  title?: string;
  /** Pull Request description (optional) */
  body?: string;
}

/**
 * Response when creating a Pull Request
 */
export interface CreatePullRequestResponse {
  /** Success message */
  message: string;
  /** Created Pull Request URL */
  pullRequestUrl: string;
  /** Pull Request number */
  pullRequestNumber: number;
  /** Created branch name */
  branchName: string;
}
/** @public */
export const accentuateApiRef = createApiRef<AccentuateApi>({
  id: 'plugin.aceituna.api',
});
